// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"324":"b5e66c0a","705":"cbbf0571","872":"cbbf0571"}[chunkId] + ".chunk.css";
};